import type { ComponentPropsWithoutRef } from "react";
import {
  Link as RouterLink,
  type LinkProps as RouterLinkProps,
} from "react-router-dom";

type Props = Omit<RouterLinkProps, "to"> & {
  href?: string;
  to?: RouterLinkProps["to"];
  /** Next.js Link prop — ignored in SPA. */
  scroll?: boolean;
  prefetch?: boolean;
  replace?: boolean;
} & Omit<ComponentPropsWithoutRef<"a">, "href">;

/** Drop-in for next/link — accepts `href` or `to`. */
export default function Link({
  href,
  to,
  scroll: _scroll,
  prefetch: _prefetch,
  ...props
}: Props) {
  return <RouterLink to={to ?? href ?? "/"} {...props} />;
}
